import { ensureSafeComponent } from '@embroider/util';
import { importSync } from '@embroider/macros';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import ENV from 'client-portal/config/environment';
import InfinityModel from 'ember-infinity/lib/infinity-model';
import Super from './-resources';

const ExtendedInfinityModel = InfinityModel.extend({
  buildParams() {
    let params = this._super(...arguments);
    params.page = { before: this.before, size: ENV.maxPageSize };
    return params;
  },

  afterInfinityModel(model) {
    this.set('canLoadMore', model.length >= ENV.maxPageSize);
    this.set('before', model.get('lastObject.cursorId'));
  },
});

export default class SiteBillingAccountHistory extends Super {
  @service store;
  @service infinity;

  get items() {
    return this.queryTask.lastSuccessful?.value;
  }

  constructor() {
    super(...arguments);
    this.performQuery();
  }

  async performQuery() {
    try {
      await this.queryTask.perform();
    } catch {
      // NOTE: template handles isError
    }
  }

  @(task(function* () {
    let include = ['invoiceItems', 'invoiceItems.invoice', 'appointmentClient'].join(',');

    let fields = {
      appointments: 'invoiceItems,startTime,fee',
      groupAppointments: 'invoiceItems,startTime,appointmentClient',
      invoiceItems: 'allocatedAmount,price,issueDate,remainingAmount,invoice',
      payments: 'paidAt,amount',
    };

    let items = this.infinity.model(
      'polymorphic/billing-item',
      {
        filter: {
          thisType: 'billable-item,payment',
          thisTypeCondition: 'unallocated',
        },
        perPageParam: null,
        pageParam: null,
        include,
        fields,
      },
      ExtendedInfinityModel
    );

    return yield items;
  }).keepLatest())
  queryTask;

  get rows() {
    if (!this.items) {
      return [];
    }

    return this.items.toArray().map(model => {
      try {
        let module = importSync(
          `../../../components/site/billing/account-history/containers/${model.constructor.modelName}`
        );
        model.containerComponent = ensureSafeComponent(module.default, this);
        return model;
      } catch (error) {
        return model;
      }
    });
  }
}
